<template>
  <div class="row">
    <div class="col-4 seperator" :class="{'error': endValueSmallerThanStartValue}">
      <InputElement
        type="text"
        :name="name + 'From'"
        placeholder="From"
        :is-disable="isDisable"
        v-model:value="inputModel.valueStart"
      />
    </div>
    <div class="col-4" :class="{'error': endValueSmallerThanStartValue}">
      <InputElement
        type="text"
        :name="name + 'To'"
        placeholder="To"
        :is-disable="isDisable"
        v-model:value="inputModel.valueEnd"
      />
    </div>
    <div class="col-4">
      <SelectableDropdownElement
        title="Select One"
        v-model:value="inputModel.selectedOption"
        :options="options"
        type="buttonselect"
      />
    </div>
  </div>

  <div v-if="endValueSmallerThanStartValue" class="validation-error">
    <LucideIcon :icon="validationError.icon"/>
    <span>{{ validationError.msg }}</span>
  </div>

</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import { AbstractInputComponent } from '@shared/components/abstracts';
import { type DropdownNs } from '@shared/types';
import SelectableDropdownElement from '../dropdown/selectable-dropdown.element.vue';
import InputElement from '../input/input.element.vue';

interface RangeValueInterface {
  valueStart: string,
  valueEnd: string,
  selectedOption: string,
}

export default defineComponent({
  name: 'InputRangeElement',
  extends: AbstractInputComponent,
  components: {
    SelectableDropdownElement,
    InputElement,
  },
  props: {
    value: {
      type: Object as PropType<RangeValueInterface>,
      required: true,
    },
    options: {
      type: Array as PropType<DropdownNs.DropdownOptionsItem[]>,
      required: true,
    },
  },
  data() {
    return {
      numberFilterRegex: new RegExp('^[0-9]*$'),
      dotExceptionRegex: new RegExp('\\..*'),
      endValueSmallerThanStartValue: false,
      validationError: {
        icon: 'Info',
        msg: 'The value in the first field must be smaller.',
      },
    };
  },
  computed: {
    inputModel: {
      get(): any {
        return this.value;
      },
      set(value: any): void {
        this.$emit('update:value', value);
      },
    },
  },
  methods: {
    inputValueNumberAndDotFilter(event: any) {
      if (
        !event.key.match(this.numberFilterRegex)
        && !event.key.match(this.dotExceptionRegex)
      ) {
        event.preventDefault();
      }
      if (
        event.target.value.includes('.')
        && event.key.match(this.dotExceptionRegex)
      ) {
        event.preventDefault();
      }
    },
    fixValueStartOnFocusOut(event: any) {
      if (!event.target.value.includes('.') && event.target.value !== '') {
        event.target.value += '.00';
        this.inputModel.valueStart = event.target.value;
      }
      this.rangeValueComparison(
        parseFloat(this.inputModel.valueStart),
        parseFloat(this.inputModel.valueEnd),
      );
    },
    fixValueEndOnFocusOut(event: any) {
      if (!event.target.value.includes('.') && event.target.value !== '') {
        event.target.value += '.00';
        this.inputModel.valueEnd = event.target.value;
      }
      this.rangeValueComparison(
        parseFloat(this.inputModel.valueStart),
        parseFloat(this.inputModel.valueEnd),
      );
    },
    rangeValueComparison(startValue: number, endValue: number) {
      if (startValue && endValue) {
        this.endValueSmallerThanStartValue = endValue < startValue;
      }
    },
  },
});
</script>

<style lang="scss" scoped>

.seperator {
  position: relative;

  &::after {
    content: "-";
    position: absolute;
    right: -2px;
    top: 7px;
    color: var(--neutral-300)

  }
}

</style>
